<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon dark fab color="secondary" v-bind="attrs" v-on="on" class="mt-4"> </v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">チェック内容編集</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-sheet elevation="0" class="pa-2">
				<v-form ref="form" v-model="valid">
					<table width="100%" class="show-dialog-table">
						<tbody>
							<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'工程'">
								<template v-slot:value>
									<p>{{ check_process.check_process_type.name }}</p>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'チェック項目'">
								<template v-slot:value>
									({{ check_item.order_number }}/{{
										check_process.check_process_type.check_items.length
									}}) {{ check_item.name }}
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'チェック方法'">
								<template v-slot:value>
									<p>{{ check_item.check_method }}</p>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'チェック基準'">
								<template v-slot:value>
									<p>{{ check_item.standard }}</p>
								</template>
							</ShowDetailRecord>
							<CheckValueForm :check_value.sync="checkValue" :check_item="check_item" />
							<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="''">
								<template v-slot:value>
									<v-textarea
										ref="reason"
										label="変更理由(必須)"
										v-model="reason"
										:rules="[rules.required]"
										class="mt-4"
										outlined
										dense
										auto-grow
									/>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
					<v-row class="mt-4" no-gutters justify="center">
						<v-btn color="secondary" @click="submitForm" :disabled="!valid">
							<v-icon class="mr-1">mdi-pencil</v-icon>
							編集
						</v-btn>
					</v-row>
				</v-form>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import CheckValueForm from "./CheckValueForm.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		check_item: {
			type: null,
			required: false,
		},
		check_value: {
			type: null,
			required: false,
		},
		check_process: {
			type: null,
			required: false,
		},
	},
	components: {
		ShowDetailRecord,
		CheckValueForm,
	},
	data() {
		return {
			checkValue: {},
			valid: false,
			reason: null,
			common,
			rules,
		}
	},
	methods: {
		submitForm() {
			const headers = authenticate.setHeader()
			const params = { check_value: this.checkValue, reason: this.reason }
			const url = `/erp/v1/check_values/${this.check_value.id}}`
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.closeDialog()
					this.$emit("check", res.data.check_unit, res.data.check_item)
					this.editDialog = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		closeDialog() {
			this.showDialog = false
			this.$refs.reason.reset()
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		check_value(newVal) {
			const targetValue = newVal.value
			const matchingKeys = Object.keys(newVal).filter((key) => newVal[key] === targetValue)

			const result = {}
			matchingKeys.forEach((key) => {
				result[key] = newVal[key]
			})
			delete result.value
			this.checkValue = result
		},
		deep: true,
	},
}
</script>
